<template>
    <div class="card contextCardTree">
        <div @click="addParent" class="contextButtonTree bottomBorderTree">
            <i style="text-align: center;width: 1rem;" class="dropIcon me-1 fas fa-male"></i>
            New Module
        </div>
        <div @click="addChild" class="contextButtonTree bottomBorderTree">
            <i style="text-align: center;width: 1rem;" class="dropIcon me-1 fas fa-child"></i>
            Add SOP Group
        </div>
        <div @click="editItem" class="contextButtonTree bottomBorderTree">
            <i style="text-align: center;width: 1rem;" class="dropIcon me-1 fas fa-trash"></i>
            Edit
        </div>
        <div @click="deleteItem" class="contextButtonTree bottomBorderTree">
            <i style="text-align: center;width: 1rem;" class="dropIcon me-1 fas fa-trash"></i>
            Delete
        </div>
    </div>
</template>

<script>
export default {
    props:{
        item_id:{}
    },
    data:() => ({}),
    computed:{
        
    },
    methods:{
        addChild(){
            this.$emit('action', 'add_child');
        },
        addParent(){
            this.$emit('action', 'add_parent');
        },
        deleteItem(){
            this.$emit('action', 'delete');
        },
        linkItem(){
            this.$emit('action', 'link');
        },
        editItem(){
            this.$emit('action', 'edit');
        }
    },
    mounted(){},
}
</script>

<style>
.bottomBorderTree{
    border-bottom: 1px solid rgb(59, 59, 59);
}
.contextCardTree{
    box-shadow: rgb(0 0 0 / 18%) 0px 16px 48px 0px;
    width: 10rem;
    border: 1px solid green !important;
}
.contextButtonTree{
    padding: 0.6rem;
    /*font-family: Roboto;*/
    font-style: normal;
    font-weight: normal;
    font-size: 0.8rem;
    /*line-height: 21px;*/
}
.contextButtonTree:hover{
    border-radius: 0.2rem;
    cursor: pointer;
    color: #FFFFFF;
    background: radial-gradient(90.79% 1306.93% at 74.93% 34.21%, #05B15F 0%, #019750 100%);
}
.contextCloseTree{
    padding: 0.6rem;
    /*font-family: Roboto;*/
    font-style: normal;
    font-weight: normal;
    font-size: 0.8rem;
    background: radial-gradient(90.79% 1306.93% at 74.93% 34.21%, #e69705 0%, #ffd000 100%);
}

</style>